import { render, staticRenderFns } from "./ExternalPosHub.vue?vue&type=template&id=52fe52bd"
import script from "./ExternalPosHub.vue?vue&type=script&lang=js"
export * from "./ExternalPosHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports